import Module from '../../Module';
import mock from './mock';
import { Product } from '../';
import services from 'core/services';

class Cart extends Module {
  get baseURL() {
    return '/api/v1/cart'
  }

  initMock(handler) {
    mock(this.handler)
  }

  /**
   * parse cart
   * @param {Array} cart 
   */
  parseCart(cart) {
    if ( !cart ) return []

    return cart.map(c => {
      return this.parseCartItem(c);
    });
  };

  /**
   * parse item of cart
   * @param {Object} cart 
   */
  parseCartItem(cart) {
    return {
      active: cart.active,
      clientId: cart.clientId,
      count: cart.count,
      createdAt: cart.createdAt,
      customerId: cart.customerId,
      deletedAt: cart.deletedAt,
      id: cart.id,
      orderId: cart.orderId,
      productId: cart.productId,
      updatedAt: cart.updatedAt,
      product: cart.product ? Product.parseProduct(cart.product) : null,
    }
  }

  /**
   * get cart
   */
  getCart(params) {
    return new Promise(( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}`, {
          params: {
            ...params
          }
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                cart: this.parseCart(data.cart),
                price: {
                  sumAfter: data.sumAfter,
                  sumBefore: data.sumBefore,
                  sumOfDiscounts: data.sumOfDiscounts,
                }
              }))
            )
          })
          .catch(e => {
            reject(e)
          })
    })
  };

  /**
   * add to cart
   */
  addToCart(product, params) {
    return new Promise(( resolve, reject ) => {
      this.handler
        .post(`${this.baseURL}`, {
          data: product,
          params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                cart: this.parseCart(data.cart),
                price: {
                  sumAfter: data.sumAfter,
                  sumBefore: data.sumBefore,
                  sumOfDiscounts: data.sumOfDiscounts,
                }
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponseError(e))
          })
    })
  };

  changeCountItem(id, product, params) {
    return new Promise(( resolve, reject ) => {
      this.handler
        .put(`${this.baseURL}/${id}`, {
          data: product,
          params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                cart: this.parseCart(data.cart),
                price: {
                  sumAfter: data.sumAfter,
                  sumBefore: data.sumBefore,
                  sumOfDiscounts: data.sumOfDiscounts,
                }
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponseError(e))
          })
    })
  }

  deleteItem(id, params) {
    return new Promise(( resolve, reject ) => {
      this.handler
        .delete(`${this.baseURL}/${id}`, {
          params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                cart: this.parseCart(data.cart),
                price: {
                  sumAfter: data.sumAfter,
                  sumBefore: data.sumBefore,
                  sumOfDiscounts: data.sumOfDiscounts,
                }
              }))
            )
          })
          .catch(e => {
            reject(e)
          })
    })
  }

  deleteCart() {
    return new Promise(( resolve, reject ) => {
      this.handler
        .delete(`${this.baseURL}/wipe`)
          .then(r => {
            resolve(r)
          })
          .catch(e => {
            reject(e)
          })
    })
  }
};

export default new Cart();
